import { animate, style, transition, trigger } from '@angular/animations'
import { CommonModule } from '@angular/common'
import { Component, Input, SimpleChanges, ViewChild } from '@angular/core'
import { NavigationStart, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { TranslateModule } from '@ngx-translate/core'
import { InlineSVGModule } from 'ng-inline-svg-2'
import { MenuItem } from 'primeng/api'
import { ButtonModule } from 'primeng/button'
import { MenuModule } from 'primeng/menu'
import { combineLatest, Subscription } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { $app } from '../../app.service'
import { AppProject } from '../../shared/models/interfaces/app-project.interface'
import { toggleSidebar } from '../../shared/store/stage/stage.actions'
import { getStatuses, selectIsSidebarOpen } from '../../shared/store/stage/stage.selectors'
import { AppState } from '../../shared/store/storage'
import { AppProgressbarComponent } from '../../shared/components/app-progressbar/app-progressbar.component'
import { AppStatutesBorderBottomPipe } from '../../shared/pipes/app-statutes-border-bottom/app-statutes-border-bottom.pipe'
import { AppStatutesIconsPipe } from '../../shared/pipes/app-statutes-icons/app-statutes-icons.pipe'
import { AppStatutesPipe } from '../../shared/pipes/app-statutes/app-statutes.pipe'
import * as LumpSumActions from '../../shared/store/lump-sum/lump-sum.actions'
import { selectLumpSumExportProgress } from '../../shared/store/lump-sum/lump-sum.selectors'
import * as ProjectActions from '../../shared/store/project/project.actions'
import { selectProjectExportProgress } from '../../shared/store/project/project.selectors'

@Component({
   selector: 'status-topbar',
   templateUrl: './status-topbar.component.html',
   animations: [
      trigger('inOut', [
         transition(':enter', [style({ transform: 'translateX(-100%)', opacity: 0 }), animate(500)]),
         transition(':leave', [style({ opacity: 0 }), animate(0, style({ width: 0 }))])
      ])
   ],
   standalone: true,
   imports: [
      CommonModule,
      InlineSVGModule,
      AppProgressbarComponent,
      MenuModule,
      ButtonModule,
      TranslateModule,
      AppStatutesPipe,
      AppStatutesBorderBottomPipe,
      AppStatutesIconsPipe
   ]
})
export class StatusTopbarComponent {
   @Input() allowEdit?: boolean | null
   @Input() project?: AppProject | null

   isSidebarOpen$ = this.store.select(selectIsSidebarOpen)

   statutes$ = this.store.select(getStatuses)

   progress$ = combineLatest([this.store.select(selectProjectExportProgress), this.store.select(selectLumpSumExportProgress)]).pipe(
      map(([project, lumpSum]) => (project?.isLoading ? project : lumpSum?.isLoading ? lumpSum : undefined))
   )

   items?: MenuItem[]

   private _sub = new Subscription()

   @ViewChild('menu') menu?: any
   constructor(
      private _router: Router,
      private store: Store<AppState>
   ) {}

   ngOnInit(): void {
      this.initMenuItems()

      this._sub.add(
         this._router.events
            .pipe(
               filter((event) => event instanceof NavigationStart) // ← CAMBIA QUESTO
            )
            .subscribe(() => {
               this.menu?.hide()
            })
      )
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (this.project) {
         // Always remove to avoid duplicates
         this.items = this.items?.filter((i) => i.label !== 'Download Lump Sum budget table') || []

         if (this.project?.lumpSum) {
            this.items.splice(1, 0, {
               label: 'Download Lump Sum budget table',
               icon: 'pi pi-file status-topbar-icon',
               command: (event) => {
                  this.onButtonDownload('lumpsum')
               }
            })
         }
      }
   }

   ngOnDestroy(): void {
      this._sub.unsubscribe()
   }

   toggleSidebar() {
      this.store.dispatch(toggleSidebar())
   }

   private initMenuItems() {
      this.items = [
         {
            label: 'Download Part B section 3.1',
            icon: 'pi pi-file status-topbar-icon',
            command: (event) => {
               this.onButtonDownload('word')
            }
         },
         {
            label: 'Edit data',
            icon: 'pi pi-pencil status-topbar-icon',
            command: (event) => {
               this._router.navigate([`${$app.getCurrentProjectId()}/edit-project`])
            }
         }
      ]
   }

   onButtonDownload(type: 'word' | 'lumpsum') {
      type === 'word' ? this.store.dispatch(ProjectActions.exportProject()) : this.store.dispatch(LumpSumActions.downloadLumpSum())
   }
}
